<template>
    <div class="container">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="店铺名称" prop="shop_id" v-if="shops.length > 0">
                <el-select
                    v-model="queryForm.shop_id"
                    filterable
                    clearable
                    placeholder="请输入店铺">
                    <el-option
                        v-for="item in shops"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="店铺手机号" prop="mobile">
                <el-input maxlength="11" v-model="queryForm.mobile" placeholder="请输入"
                          auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="月份" prop="month">
                <el-date-picker
                    v-model="queryForm.month"
                    type="month"
                    placeholder="请选择月份">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData">查询</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <div style="width: 100%;height: 910px;">
            <IEcharts :option="option" :loading="loading"></IEcharts>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import IEcharts from 'vue-echarts-v3';
import ExportExcel from "../../components/exportExcel2.vue";

export default {
    components: { IEcharts,ExportExcel },
    data() {
        return {
            queryFormLabelWidth: '100px',//自定义查询表单label宽度
            queryForm: {//查询表单数据
                month: '',
                startDate: '',
                endDate: '',
                saasSchoolIds: 2839,
                // commercial_id: '',
                for_report: true
            },
            summary: {},

            loading: false,
            option: {
                tooltip: {
                    formatter: function (params) {
                        // if(params.value[2]){
                        //     let html = `总收款流水：${params.value[5]}元/${params.value[6]}单<br/>校方收款流水：${params.value[3]}元/${params.value[4]}单<br/>公司收款流水：${params.value[1]}元/${params.value[2]}单`;
                        //     return html;
                        // }
                    }
                },
                visualMap: {
                    show: false,
                    min: 0,
                    max: 300,
                    calculable: true,
                    seriesIndex: [2],
                    orient: 'horizontal',
                    left: 'center',
                    bottom: 20,
                    inRange: {
                        color: ['#f5f5f5', '#f5f5f5'],
                        opacity: 0.5
                    },
                    controller: {
                        inRange: {
                            color: ['#fff', '#fff'],
                            opacity: 1
                        }
                    }
                },
                calendar: [{
                    left: 'center',
                    top: 'middle',
                    cellSize: [130, 130],
                    yearLabel: {show: false},
                    orient: 'vertical',
                    dayLabel: {
                        firstDay: 1,
                        nameMap: 'cn'
                    },
                    monthLabel: {
                        show: false
                    },
//                        range: ''
                }],
                series: [{
                    type: 'scatter',
                    coordinateSystem: 'calendar',
                    symbolSize: 1,
                    label: {
                        normal: {
                            show: true,
                            formatter: function (params) {
                                if(moment(new Date()).format('YYYY-MM-DD') == params.value[0]){
                                    return params.value[0].substring(8,10) + "日\n\n今天";
                                }
                                return params.value[0].substring(8,10) + '日';
                            },
                            textStyle: {
                                color: '#333'
                            }
                        }
                    },
                    data: []
                }, {
                    type: 'scatter',
                    coordinateSystem: 'calendar',
                    symbolSize: 1,
                    label: {
                        normal: {
                            show: true,
                            formatter: function (params) {
                                //return '\n\n\n' + (params.value[3] || '');
                                let status = '';
                                if(params.value[2]){
                                    if(params.value[2].billStatus){
                                        switch (params.value[2].billStatus) {
                                            case 0:
                                                status = '未打款';
                                                break;
                                            case 2:
                                                status = '已打款';
                                                break;
                                            case 8:
                                                status = '已打款';
                                                break;
                                        }
                                    }else{
//                                            status = '已打款';
                                        status = '未打款';
                                    }
                                }
                                return '\n\n\n' + status;
                            },
                            textStyle: {
                                fontSize: 12,
                                color: '#a00'
                            }
                        }
                    },
                    data: []
                }, {
                    name: '明细',
                    type: 'heatmap',
                    coordinateSystem: 'calendar',
                    data: []
                }]
            },
            shops: JSON.parse(localStorage.getItem('shops')),
            lunarData: [],
            heatmapData: []
        }
    },
    created(){
        //默认显示最近一周
        this.queryForm.month = new Date();
        //得到该月所有日期
        let month = parseInt(moment(this.queryForm.month).format('MM'),10);
        let temp = new Date(moment(this.queryForm.month).format('YYYY'),month,0);
        for(let i=1;i<temp.getDate()+1;i++){
            if(i<10) i = '0' + i;
            this.lunarData.push([moment(this.queryForm.month).format('YYYY-MM-')+i,1]);
            this.heatmapData.push([moment(this.queryForm.month).format('YYYY-MM-')+i,Math.random() * 300]);
        }
        this.option.calendar[0].range = moment(this.queryForm.month).format('YYYY-MM');
        this.option.series[0].data = this.option.series[1].data = this.lunarData;
        this.option.series[2].data = this.heatmapData;
        // this.getTableData();
    },
    methods: {
        //抓取列表数据
        fetchData() {
            // this.getSummary();
            if(!this.queryForm.shop_id){
                return this.$message.warning('请先选择店铺');
            }
            this.getTableData();
        },
        getParams() {
            let params = {...this.queryForm};
            let month = parseInt(moment(params.month).format('MM'),10);
            let temp = new Date(moment(params.month).format('YYYY'),month,0);
            params.startDate = moment(params.month).format('YYYYMM') + '01';
            params.endDate = moment(params.month).format('YYYYMM') + temp.getDate();

            delete params.month;
            return params;
        },
        getSummary() {
            let params = this.getParams();
            this.$apiJava.post(this.$apiUrl.financePayBillSummary,params,(res)=>{
                this.summary = res.data;
            },null,'finance')
        },
        getTableData() {
            let params = this.getParams();
            this.$apiJava.post(this.$apiUrl.financePayBill,params,(res)=>{
                this.loading = false;
                //this.tableData = res.data || [];
                let month = parseInt(moment(this.queryForm.month).format('MM'),10);
                let temp = new Date(moment(this.queryForm.month).format('YYYY'),month,0);
                for(let i=1;i<temp.getDate()+1;i++){
                    if(i<10) i = '0' + i;
                    if(res.data.length>0){
                        for(var j=0;j<res.data.length;j++){
                            if(res.data[j].businessDate && i == res.data[j].businessDate.substring(6,8)){
                                this.lunarData.push([moment(this.queryForm.month).format('YYYY-MM-')+i,1,res.data[j]]);
                                this.heatmapData.push([moment(this.queryForm.month).format('YYYY-MM-')+i,res.data[j].totalCashFlow,res.data[j].commercialOrderSum,res.data[j].schoolCashFlow,res.data[j].schoolOrderSum,res.data[j].totalCashFlow,res.data[j].totalOrderSum]);
                            }
                        }
                    }
                }
                this.option.series[0].data = this.option.series[1].data = this.lunarData;
                this.option.series[2].data = this.heatmapData;

            },(res)=>{
                this.$message.warning(res.message);
//                    this.tableData = [];
            },'finance')
        },
        //表单重置 item上需要添加prop属性
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    },
    remoteShopMethod(query){
        if (query !== '') {
            this.shopList = [];
            var arr = [];
            let len = this.shops.length;
            var reg = new RegExp(query);
            for(var i=0;i<len;i++){
                //如果字符串中不包含目标字符会返回-1
                if(this.shops[i].name.match(reg)){
                    this.shopList.push(this.shops[i]);
                }
            }
        } else {
            this.shopList = [];
        }
    },
}
</script>
<style lang="scss"  scoped>
.el-card{
    border: none;
    box-shadow: none;
}
</style>


// WEBPACK FOOTER //
// payment.vue?03437b6b